import { Eye } from 'lucide-react';
import {
  formatReviewDate,
  isReviewRole,
  reviewRoleLabel,
} from '../reviewAccess';
import { useUserStore } from '@/entities/user/store';

/**
 * Shown on every page to a Review-role reviewer: "read-only, expires <date>".
 *
 * A reminder, not a control. The end date and the read-only rule are enforced
 * by the API on each request, whatever this banner shows.
 */
export function ReviewAccessBanner() {
  const user = useUserStore((s) => s.user);
  if (!user || !isReviewRole(user.orgRole)) return null;

  return (
    <div
      role="status"
      data-name="ReviewAccessBanner"
      className="flex shrink-0 items-center gap-2 border-b border-amber-300 bg-amber-50 px-6 py-2 text-[13px] text-amber-950"
    >
      <Eye className="h-4 w-4 text-amber-700" aria-hidden />
      <span>
        <strong>{reviewRoleLabel()} access: read-only.</strong>{' '}
        {user.reviewAccessExpiresAt
          ? `Expires ${formatReviewDate(user.reviewAccessExpiresAt)}.`
          : 'Ends when the workspace admin says so.'}
      </span>
    </div>
  );
}
